const CONTEXT_LATEST_DESIGN_VERSION = 8;
export { CONTEXT_LATEST_DESIGN_VERSION };